import { CommunityId } from './community.types';
import { AuthorId, PostId } from './post.types';

export type ModerationMode = 'reported' | 'blocked';

// Mirrors community-service report-reason.enum.ts ordinals.
export const REASON_LABELS: Record<number, string> = {
  0: "Don't like it",
  1: 'Spam',
  2: 'Nudity',
  3: 'Hate speech',
  4: 'Harassment',
  5: 'Scam',
  6: 'False information',
  7: 'IP violation',
  8: 'Other',
};

export const reasonLabel = (reason: number | null | undefined): string | null =>
  reason === null || reason === undefined
    ? null
    : REASON_LABELS[reason] ?? 'Other';

export type ReportedPost = {
  activityId: string;
  communityId: CommunityId;
  isReply: boolean;
  parentPostId: PostId | null;
  authorId: AuthorId;
  authorName: string;
  authorAvatar: string;
  text: string;
  timeAgo: string;
  reportCount: number;
  reasons: string[];
  reportIds: number[];
};

export type ReportedPostItem = ReportedPost & { isAuthorBlocked: boolean };

export type BlockedCommunityUser = {
  userId: AuthorId;
  communityId: CommunityId;
  name: string;
  avatar: string;
  blockedAtLabel: string;
  itemsRemovedCount: number;
};

export type ModerationFeed = {
  reported: ReportedPost[];
  blocked: BlockedCommunityUser[];
};

export const postKey = (
  post: Pick<ReportedPost, 'communityId' | 'activityId'>,
): string => `${post.communityId}:${post.activityId}`;

export const userKey = (user: {
  communityId: CommunityId;
  userId: AuthorId;
}): string => `${user.communityId}:${user.userId}`;
